import { TextInputCombinedProps } from './types';

const usePresenter = (props: TextInputCombinedProps): TextInputCombinedProps => {
  return props;
};

export default usePresenter;
